/** "AB:CD:EF…" -- a hash shown in groups, the same shape the CA fingerprint is
 *  shown in, so the two read as the same kind of thing: something to compare,
 *  not something to skim. Protocol version signatures use it. */
export function groupHash(hash, groups = 8) {
  if (!hash) return '';
  return (hash.match(/.{1,4}/g) || []).slice(0, groups).join(' ').toUpperCase();
}
